"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JOIN_SKELETON = exports.JOIN_MENU_TILE_LINK = exports.JOIN_MENU_TILE_DESCRIPTION = exports.JOIN_MENU_ROOT = exports.JOIN_MENU_BACKDROP = exports.JOIN_LABEL = exports.JOIN_BUTTON = void 0;
const JOIN_SKELETON = exports.JOIN_SKELETON = 'join-skeleton';
const JOIN_LABEL = exports.JOIN_LABEL = 'join-label';
const JOIN_MENU_ROOT = exports.JOIN_MENU_ROOT = 'join-menu-root';
const JOIN_MENU_TILE_LINK = exports.JOIN_MENU_TILE_LINK = 'join-menu-tile-link';
const JOIN_MENU_TILE_DESCRIPTION = exports.JOIN_MENU_TILE_DESCRIPTION = 'join-menu-tile-description';
const JOIN_MENU_BACKDROP = exports.JOIN_MENU_BACKDROP = 'join-menu-backdrop';
const JOIN_BUTTON = exports.JOIN_BUTTON = 'join-button';